/* Castle Gothic - zakładki w sekcjach cg-* (delegacja zdarzeń, działa też po przeładowaniu sekcji w edytorze) */
(function () {
  if (window.cgTabsReady) return;
  window.cgTabsReady = true;

  // Wczytaj zdjęcia z zakładki z wyprzedzeniem (ukryte zakładki mają loading="lazy", więc same się nie ładują)
  function warm(tab) {
    if (!tab || tab.dataset.cgWarm) return;
    tab.dataset.cgWarm = '1';
    var root = tab.closest('.cg-sec') || document;
    var panel = root.querySelector('#' + tab.getAttribute('aria-controls'));
    if (!panel) return;
    var camp = root.querySelector('[data-cg-campaign-for="' + tab.getAttribute('aria-controls') + '"] img[loading="lazy"]');
    if (camp) camp.loading = 'eager';
    panel.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (!img.classList.contains('cg-card__img2')) img.loading = 'eager';
    });
  }

  ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var tab = e.target && e.target.closest && e.target.closest('.cg-sec [role="tab"]');
      if (tab) warm(tab);
    }, { passive: true, capture: type === 'pointerenter' });
  });

  // Po załadowaniu strony, w wolnej chwili, dociągnij zdjęcia ze wszystkich zakładek w sekcjach widocznych w pobliżu
  function warmNear() {
    var tabs = document.querySelectorAll('.cg-sec [role="tab"][aria-selected="false"]');
    if (!('IntersectionObserver' in window)) { tabs.forEach(warm); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.querySelectorAll('[role="tab"][aria-selected="false"]').forEach(warm);
        io.unobserve(en.target);
      });
    }, { rootMargin: '600px 0px' });
    var seen = [];
    tabs.forEach(function (t) {
      var list = t.closest('[role="tablist"]');
      if (list && seen.indexOf(list) === -1) { seen.push(list); io.observe(list); }
    });
  }
  window.addEventListener('load', function () {
    (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(warmNear);
  });

  function select(tab) {
    warm(tab);
    var list = tab.closest('[role="tablist"]');
    if (!list) return;
    var root = tab.closest('.cg-sec') || document;
    list.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    // zdjęcie kampanii przypisane do zakładki
    var camps = root.querySelectorAll('[data-cg-campaign-for]');
    if (camps.length > 1) {
      camps.forEach(function (c) { c.hidden = c.getAttribute('data-cg-campaign-for') !== tab.getAttribute('aria-controls'); });
    }
    // link "Zobacz wszystkie" prowadzi do kolekcji aktywnej zakładki
    var link = root.querySelector('[data-cg-tablink]');
    if (link && tab.getAttribute('data-cg-link-url')) {
      link.href = tab.getAttribute('data-cg-link-url');
      var span = link.querySelector('span');
      if (span) span.textContent = tab.getAttribute('data-cg-link-text');
    }
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.cg-sec [role="tab"]');
    if (tab) select(tab);
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest('.cg-sec [role="tab"]');
    if (!tab || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) === -1) return;
    var tabs = Array.prototype.slice.call(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab);
    if (e.key === 'ArrowRight') i = (i + 1) % tabs.length;
    if (e.key === 'ArrowLeft') i = (i - 1 + tabs.length) % tabs.length;
    if (e.key === 'Home') i = 0;
    if (e.key === 'End') i = tabs.length - 1;
    e.preventDefault();
    tabs[i].focus();
    select(tabs[i]);
  });
})();

/* Castle Gothic - mega menu: zdjęcia w panelach mają loading="lazy" i są ukryte, więc ładowały się dopiero po otwarciu.
   Wczytujemy je z wyprzedzeniem: gdy kursor wejdzie na pasek menu (albo fokus / dotyk), a na desktopie także w wolnej chwili po załadowaniu strony. */
(function () {
  if (window.cgMegaWarmReady) return;
  window.cgMegaWarmReady = true;
  var done = false;
  function warmMenu() {
    if (done) return;
    done = true;
    document.querySelectorAll('.mg-mm__img img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  function bind() {
    var nav = document.querySelector('.site-nav');
    if (!nav) return;
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (t) {
      nav.addEventListener(t, warmMenu, { passive: true, once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  window.addEventListener('load', function () {
    if (!window.matchMedia || !window.matchMedia('(min-width: 769px)').matches) return;
    setTimeout(function () { (window.requestIdleCallback || function (f) { f(); })(warmMenu); }, 1500);
  });
})();
